import { createAsyncThunk } from "@reduxjs/toolkit";

import { requestStorage } from "../apiRequests/requestStorage";
import { requestCartAddJson } from "../apiRequests/requestCartAddJson";

export const requestAddToCart_Aggregated = createAsyncThunk(
  "thunks/requestAddToCart_Aggregated",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const { requests, Uterum, Result } = state;
    const { apiConfigs } = requests;
    const { ErpArticleNumbers } = Result;

    const aggregatedResponse = await requestStorage({
      method: "post",
      apiConfigs,
      data: {
        uterum: Uterum,
      },
      onSuccess: (response) => {
        const Key = response.data;

        return requestCartAddJson({
          apiConfigs,
          tentativeData: { Key, ErpArticleNumbers },
          onSuccess: () => ({ data: null }),
        });
      },
    });

    return aggregatedResponse.data;
  }
);
